export enum SelectionPanelDropShadowType {
    None = 'noShadow',
    Small = 'smallShadow',
    Medium = 'mediumShadow',
}
